import type { TypedDocumentNode } from '@apollo/client';

import MARK_READ from './markNotificationCenterRead.mutation.graphql';
import type {
  MarkNotificationCenterReadMutation,
  MarkNotificationCenterReadMutationVariables,
} from './markNotificationCenterRead.mutation.graphql';
import PREFERENCES from './notificationCenterPreferences.query.graphql';
import type {
  NotificationCenterPreferencesQuery,
  NotificationCenterPreferencesQueryVariables,
} from './notificationCenterPreferences.query.graphql';
import NOTIFICATION_CENTER from './notificationCenter.query.graphql';
import type {
  NotificationCenterQuery,
  NotificationCenterQueryVariables,
} from './notificationCenter.query.graphql';
import UPDATE_PREFERENCES from './updateNotificationCenterPreferences.mutation.graphql';
import type {
  UpdateNotificationCenterPreferencesMutation,
  UpdateNotificationCenterPreferencesMutationVariables,
} from './updateNotificationCenterPreferences.mutation.graphql';
import UNREAD_COUNT from './notificationCenterUnreadCount.query.graphql';
import type {
  NotificationCenterUnreadCountQuery,
  NotificationCenterUnreadCountQueryVariables,
} from './notificationCenterUnreadCount.query.graphql';

export const NOTIFICATION_CENTER_QUERY = NOTIFICATION_CENTER as TypedDocumentNode<
  NotificationCenterQuery,
  NotificationCenterQueryVariables
>;
export const NOTIFICATION_CENTER_UNREAD_COUNT_QUERY = UNREAD_COUNT as TypedDocumentNode<
  NotificationCenterUnreadCountQuery,
  NotificationCenterUnreadCountQueryVariables
>;
export const MARK_NOTIFICATION_CENTER_READ_MUTATION = MARK_READ as TypedDocumentNode<
  MarkNotificationCenterReadMutation,
  MarkNotificationCenterReadMutationVariables
>;

export const NOTIFICATION_CENTER_PREFERENCES_QUERY = PREFERENCES as TypedDocumentNode<
  NotificationCenterPreferencesQuery,
  NotificationCenterPreferencesQueryVariables
>;
export const UPDATE_NOTIFICATION_CENTER_PREFERENCES_MUTATION =
  UPDATE_PREFERENCES as TypedDocumentNode<
    UpdateNotificationCenterPreferencesMutation,
    UpdateNotificationCenterPreferencesMutationVariables
  >;

export type NotificationCenterNode = NotificationCenterQuery['notificationCenter']['nodes'][number];
